module.exports = __webpack_public_path__ + "img/hospitium-05.315216aa.jpg";